import React, { useEffect } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import HelmetBase from "../../components/HelmetBase";
import { useTranslation } from "react-i18next";
import bannerImage from "../../assets/images/Hero-section.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchTermsCondition } from "../../redux/slices/CommonSlice";

const TermsConditions = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { termsCondition } = useSelector((state) => state.commonStore);

  useEffect(() => {
    dispatch(fetchTermsCondition());
  }, [dispatch]);
  
  return (
    <>
      <HelmetBase
        title={`${t("Terms & Conditions")}`}
        name={`${t("Terms & Conditions")}`}
      />
      <Navbar />

      {/* <section className="hero-section2" id="home"
        style={{ backgroundImage: `url(${bannerImage})` }}
      >
        <div className="container">
          <div className="hero-text">
            <h1>Terms of Use</h1>
          </div>
        </div>
      </section>

      <section className="about-section" id="about">
        <div className="container">
          <iframe
            src="https://redsparkte.a2hosted.com/BestAlert/cms-page/2/en"
            style={{
              width: "100%",
              height: "100vh",
              border: "none",
            }}
            title="External Content"
          />
        </div>
      </section> */}
      <section
        className="hero-section2"
        id="home"
        style={{
          backgroundImage: termsCondition?.banner_image
            ? `url(${termsCondition?.banner_image})`
            : `url(${bannerImage})`,
        }}
      >
        <div className="container">
          <div className="hero-text">
            <h1>{termsCondition?.name}</h1>
          </div>
        </div>
      </section>
      <section className="about-section" id="about">
        <div className="container">
          <div className="row">
            <div
              className="col-sm-12 about-text"
              dangerouslySetInnerHTML={{ __html: termsCondition?.content }}
            ></div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default TermsConditions;
